import React, { useEffect, useState } from 'react';
import Loading from '../../../components/loading/Loading';
import useStyles from './styles';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Divider,
    Typography,
} from '@material-ui/core';
import { useApolloClient } from '@apollo/client';
import StancerOneOffPaymentContainer from './StancerOneOffPaymentContainer';
import { getSavedCardDetails } from './stancer.util';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StancerSavedCardFlow from './StancerSavedCardFlow';

/**
 * @name StancerPaymentMethods -  component for Stancer flow
 * @param {object} props - Object containing react props
 * @returns {className.Element} - Renders StancerPaymentMethods component
 */
const StancerPaymentMethods = props => {
    const graphql = useApolloClient();
    const classes = useStyles();
    const [savedCards, setSavedCards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState('payWithSavedCard');
    const [hpp, setHpp] = useState(null);
    const [loadCvc, setLoadCvc] = useState(false);

    /**
     * @handleChange - Handles teh expansion state of an accordian panel
     * @param {string} panel -Panel being toggled
     * @returns {function} A function that updates the expanded state based on the panel
     */
    const handleChange = panel => newExpanded => {
        setExpanded(newExpanded ? panel : false);
    };

    useEffect(() => {
        props.setHeader('Payment summary');
    }, []);

    useEffect(() => {
        if (savedCards?.length === 0) {
            setExpanded('payWithAnotherCard');
        } else {
            setExpanded('payWithSavedCard');
        }
    }, [savedCards?.length]);

    useEffect(() => {
        getSavedCardDetails({ graphql, setSavedCards, setLoading });
    }, []);

    return (
        <React.Fragment>
            <Box className={classes.methods}>
                {loading && <Loading />}
                {!loading && (
                    <>
                        {savedCards?.length > 0 ? (
                            <>
                                <Accordion
                                    className={classes.toggleAccordionRoot}
                                    expanded={expanded === 'payWithSavedCard'}
                                    onChange={handleChange('payWithSavedCard')}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            <ExpandMoreIcon className={classes.expandMoreIcon} />
                                        }
                                        aria-controls='pay-with-saved-card'
                                        id='pay-with-saved-card'
                                    >
                                        <Typography variant='h5' className={classes.methodTitle}>
                                            {savedCards?.length === 1
                                                ? 'Previously saved card'
                                                : 'Pick a saved card'}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.details}>
                                        <StancerSavedCardFlow
                                            cards={savedCards}
                                            handleBack={props?.handleBack}
                                            setStatus={props?.setStatus}
                                            handleNext={props?.handleNext}
                                            setHeader={props?.setHeader}
                                            handleMultiPaymentData={props?.handleMultiPaymentData}
                                            toggle={props?.toggle}
                                            setPaidAmount={props?.setPaidAmount}
                                            payableAmount={props?.payableAmount}
                                            hpp={hpp}
                                            loadCvc={loadCvc}
                                            setHpp={setHpp}
                                            setLoadCvc={setLoadCvc}
                                            graphql={graphql}
                                            setLoading={setLoading}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                                <Divider />
                                <Accordion
                                    className={classes.toggleAccordion}
                                    expanded={expanded === 'payWithAnotherCard'}
                                    onChange={handleChange('payWithAnotherCard')}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            <ExpandMoreIcon className={classes.expandMoreIcon} />
                                        }
                                        aria-controls='pay-with-another-card'
                                        id='pay-with-another-card'
                                    >
                                        <Typography variant='h5' className={classes.methodTitle}>
                                            Pay with another card
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {expanded === 'payWithAnotherCard' && (
                                            <StancerOneOffPaymentContainer
                                                payableAmount={props?.payableAmount}
                                                handleBack={props?.handleBack}
                                                setStatus={props?.setStatus}
                                                handleNext={props?.handleNext}
                                                setHeader={props?.setHeader}
                                                handleMultiPaymentData={
                                                    props?.handleMultiPaymentData
                                                }
                                                toggle={props?.toggle}
                                                setPaidAmount={props?.setPaidAmount}
                                            />
                                        )}
                                    </AccordionDetails>
                                </Accordion>
                            </>
                        ) : (
                            <StancerOneOffPaymentContainer
                                payableAmount={props?.payableAmount}
                                handleBack={props?.handleBack}
                                setStatus={props?.setStatus}
                                handleNext={props?.handleNext}
                                setHeader={props?.setHeader}
                                handleMultiPaymentData={props?.handleMultiPaymentData}
                                toggle={props?.toggle}
                                setPaidAmount={props?.setPaidAmount}
                            />
                        )}
                    </>
                )}
            </Box>
        </React.Fragment>
    );
};

export default StancerPaymentMethods;
